import { isObjectLike, reduce } from 'lodash';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';

type TranslationFn = (args: any) => any;

export type ProcessLocaleKeysOptions = {
  __t: TranslationFn;
  [key: string]: any;
};

type AnyObject = {
  [key: string]: any;
};

const processLocaleData = (
  data: AnyObject | AnyObject[],
  options: ProcessLocaleKeysOptions
): any => {
  return reduce(
    data,
    function (result, value: any, key: string) {
      // console.log('result, value, key', {result, value, key});
      if (Array.isArray(value)) {
        // @ts-ignore
        result[key] = value.map((value2) => processLocaleData(value2, options));
      } else if (
        isObjectLike(value) &&
        value.hasOwnProperty('localeKey') &&
        value.hasOwnProperty('ns')
      ) {
        // @ts-ignore
        result[key] = options.__t(value.localeKey, value.ns);
      } else if (
        isObjectLike(value) &&
        value.$$typeof === 'Symbol(react.forward_ref)'
      ) {
        // @ts-ignore
        result[key] = value;
      } else {
        // @ts-ignore
        result[key] = value;
      }
      return result;
    },
    {}
  );
};

export const processLocaleKeys = (
  data: AnyObject | AnyObject[],
  options: ProcessLocaleKeysOptions
) => {
  const outputData = processLocaleData(data, options);
  // console.log('outputData', outputData);
  return outputData;
};

export function useProcessLocaleKeys(data: AnyObject) {
  const { __t } = useTranslation();
  const options = { __t };
  return processLocaleKeys(data, options);
}
